// apps/lc/src/mocks/wireframe/modules.ts
import type { LearningModule } from './types'
import { ENROLLMENTS } from './enrollments'
import { daysAgo } from './dateUtils'

// 3 modules per active enrollment
export const MODULES: LearningModule[] = ENROLLMENTS.filter(e => e.status === 'active').flatMap(e =>
  [1, 2, 3].map(n => ({
    id: `m-${e.id}-${n}`,
    enrollmentId: e.id,
    moduleNumber: n,
    kind: n === 2 ? 'mixed' as const : 'progress' as const,
    completionPct: n === 3 ? 25 : 100,
    lessons: [1, 2, 3, 4, 5, 6].map(l => ({
      order: l,
      curriculum: e.curriculum,
      chapterNumber: n,
      chapterTitle: `${e.curriculum.toUpperCase()} 챕터 ${n}`,
      lessonNumber: l,
      lessonTitle: `${e.curriculum.toUpperCase()} ${n}-${l} 레슨`,
      kind: l === 6 ? 'monthly-test' as const : (n === 2 && l <= 2) ? 'review' as const : 'progress' as const,
      avgAccuracyFirst: n === 3 && l > 1 ? null : 60 + ((n + l) % 25),
      avgAccuracyFinal: n === 3 && l > 1 ? null : 75 + ((n + l) % 20),
      lastCompletedAt: n === 3 && l > 1 ? null : daysAgo(15 - n - l).toISOString().slice(0, 10),
      completionCount: n === 3 && l > 1 ? 0 : 1 + (l % 3),
    })),
  }))
)
